<template>
  <div class="home">
    <div class="header">
      <div class="header_left">
        <div class="header_icon"></div>
        <h1>小微企业财税服务平台</h1>
      </div>
      <div class="header_righ">
        <!-- <router-link to="/">首页</router-link>
        <router-link to="/">云托管</router-link>
        <router-link to="/">扫码开票</router-link>
        <router-link to="/">税乎</router-link> -->
        <a :href="login" class="login">登录</a>
      </div>
    </div>
    <div class="swiper-co">
      <div class="leri">
        <div class="left" @click="onleft"></div>
        <div class="right" @click="onright"></div>
      </div>
      <div class="back-bq"></div>
      <swiper
        ref="swiper"
        :autoPlay="true"
        :interval="5000"
        :showIndicator="false"
      >
        <Slide>
          <div class="back back1">
            <div class="back-1200">
              <img src="../../../public/image/fptt.png" alt="" />
              <div></div>
            </div>
          </div>
          <div class="back-bq2"></div>
        </Slide>
        <Slide>
          <div class="back back3">
            <div class="back-1200">
              <img src="../../../public/image/ytgkp.png" alt="" />
              <div></div>
            </div>
          </div>
          <div class="back-bq3"></div>
        </Slide>
        <Slide>
          <div class="back back4">
            <div class="back-1200">
              <img src="../../../public/image/cjkpsl.png" alt="" />
            </div>
          </div>
          <div class="back-bq4"></div>
        </Slide>
      </swiper>
    </div>
    <h1 class="tabs-h1">易开开，领先的托管开票平台</h1>
    <h2 class="tabs-h2">多种开票方案，解决你的各种开票需求</h2>
    <div class="home-tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="手机开票" name="mobile">
          <div class="mobile">
            <div class="mobile-left">
              <h1>无盘手机开电票</h1>
              <p>
                适用于：商贸商业、个体餐饮、自有职业者等开票时间不规律，无需固定场所，随时随地，手机开电票
              </p>
              <h2>开票流程：</h2>
              <el-steps direction="vertical">
                <el-step title="填写购方信息（模糊搜索）"></el-step>
                <el-step title="填写开票项目、金额"></el-step>
                <el-step title="发票开具成功后投递至邮箱，永久保存"></el-step>
              </el-steps>
            </div>
            <div class="mobile-righ">
              <img src="../../../public/image/u237.png" alt="" />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="扫码开票" name="Scan">
          <div class="Scan">
            <div class="scan_left">
              <h1>顾客扫码牌</h1>
              <p>适用于：酒店、餐饮等生活服务业</p>
              <h2>开票流程：</h2>
              <el-steps direction="vertical">
                <el-step title="顾客扫码牌输入抬头信息"></el-step>
                <el-step title="商家审核输入金额，点击开具"></el-step>
                <el-step title="发票开具成功后投递至邮箱，永久保存"></el-step>
              </el-steps>
            </div>
            <div class="scan_righ">
              <img src="../../../public/image/smkp.png" alt="" />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="自助开票" name="selfhelp">
          <div class="selfh">
            <div class="selfh_left">
              <h1>顾客扫小票二维码</h1>
              <p>适用于：酒店、餐饮等生活服务业</p>
              <h2>开票流程：</h2>
              <el-steps direction="vertical">
                <el-step title="商家输入金额，生成小票"></el-step>
                <el-step title="顾客扫小票二维码，输入抬头"></el-step>
                <el-step title="发票开具成功后投递至邮箱，永久保存"></el-step>
              </el-steps>
            </div>
            <div class="selfh_righ">
              <img src="../../../public/image/zzkp.png" alt="" />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="接口开票" name="Interface">
          <div class="inter">
            <div class="inter_left">
              <h1>接口无缝对接</h1>
              <p>适用于：集团企业、连锁企业、停车场、收银等行业</p>
              <h2>核心优势：</h2>
              <el-steps direction="vertical">
                <el-step title="真并发接口，拒绝假并发真排队"></el-step>
                <el-step title="金税盘、税控盘、税务UKey一网打尽"></el-step>
                <el-step title="全票种、全接口"></el-step>
              </el-steps>
            </div>
            <div class="inter_righ">
              <img src="../../../public/image/jkkp.png" alt="" />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="gywm">
      <h1>关于我们</h1>
      <div class="gywm-head">
        <div>
          <img src="../../../public/image/gywm01.png" alt="" />
          <h2>覆盖城市</h2>
          <h3>200+家</h3>
        </div>
        <div>
          <img src="../../../public/image/gywm02.png" alt="" />
          <h2>e企托共享服务器出货量</h2>
          <h3>1000+台</h3>
        </div>
        <div>
          <img src="../../../public/image/gywm03.png" alt="" />
          <h2>云托管商家</h2>
          <h3>30000+家</h3>
        </div>
        <div>
          <img src="../../../public/image/gywm04.png" alt="" />
          <h2>累计服务商家</h2>
          <h3>10万+家</h3>
        </div>
        <div>
          <img src="../../../public/image/gywm05.png" alt="" />
          <h2>HoneKit智慧<br />物联运维</h2>
          <h3>800+天</h3>
        </div>
      </div>
      <div class="gywm_footer">
        <div class="gywm_left">
          <p>
            深圳市联云计算机科技有限公司创立于2010年，于2019年获得深圳前海大数金融数百万元投资，估值1亿元，是国内领先的互联网+智能硬件综合服务运营商，产品包括“智能硬件：e企托共享服务器、税控盒子、云票打印机；财税SaaS产品：e企开SaaS平台、易开开云开票服务平台；物联网产品：HoneKit智慧物联云平台”。联云拥有发明专利、实用新型专利、外观专利、软件著作权80余项，是集专业研发、产品运营、生产制造及销售为一体的国家级高新技术企业、软件企业。
          </p>
          <p>
            2013年起，联云专业服务国内两大税控企业航天信息、百望金赋总部及其36家省公司长达7年。公司自主研发的e企托共享服务器+易开开票税云平台于2018年上线运营。已经服务大型机构客户30000+户，稳定持续运行2年，是业内托管云开票方案的领先企业。
          </p>
          <h4>旗下拥有多家全资子公司：</h4>
          <p>
            深圳市善正实业有限公司，成立于1999年，注册资本2500万。目前已通过ISO9001：2008及3C体系认证。
          </p>
          <p>
            深圳市云开日出科技有限公司，成立于2018年，是易开开云开票服务平台的专业运营子公司。
          </p>
        </div>
        <div class="gywm_righ">
          <img src="../../../public/image/u183.jpg" alt="" />
          <h4>国家高新技术企业证书</h4>
        </div>
      </div>
    </div>
    <div class="qgwd">
      <h1>全国网点</h1>
      <h2>
        深圳市云开日出科技有限公司成立于2018年，是联云科技旗下专为服务小微企业财税服务的全资控股负责运营的子公司。公司总部设立在深圳市南山区西丽，在广州、东莞、佛山、潮州、汕头、苏州、无锡、廊坊、黄石、南阳设立10家分支运营机构，并快速扩张中
      </h2>
      <div class="echarts">
        <div :style="{ height: '800px', width: '100%' }" ref="myEchart"></div>
      </div>
    </div>
    <div class="cgal">
      <h1>成功案例</h1>
      <img src="../../../public/image/u176.png" alt="" />
    </div>
    <div class="footer">
      <div class="footer_1200">
        <div class="footer_left">
          <img src="../../../public/image/rx.png" alt="" />
          <div>
            <h1>易开开全国服务热线</h1>
            <h2>400-8932-188</h2>
            <a href="https://yun.ekaikai.cn/#/serviceLogin"
              >服务商入口 <span>》</span></a
            >
          </div>
        </div>
        <div class="footer_cont">
          <p><span>公司名称</span>：深圳市云开日出科技有限公司</p>
          <p><span>公司地址</span>：深圳市南山区西丽镇大勘科技园二期C栋3楼</p>
          <p><span>开户行</span>：交通银行深圳南海支行</p>
          <p><span>银行账号</span>：443066261013001964166</p>
        </div>
        <div class="footer_righ">
          <div>
            <img :src="imgekk" alt="" />
            <p>易开开公众号</p>
          </div>
          <div>
            <img :src="imgly" alt="" />
            <p>联云公众号</p>
          </div>
        </div>
      </div>
    </div>
    <div class="lianyun">
      {{ names }}
      <p>
        <a :href="icpUrl" target="_blank">{{ icpRecord }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import { Swiper, Slide } from "vue-swiper-component";
import echarts from "echarts";
import "../../../node_modules/echarts/map/js/china.js"; // 引入中国地图数据
import provin from "../../../public/json/province.json";
import dataList from "../../../public/json/dataList.json";
import config from "../../../public/json/config.json";
export default {
  name: "",
  data() {
    return {
      activeName: "mobile",
      chart: null,
      icpRecord: "",
      icpUrl: "",
      names: "",
      login: "",
      imgekk: "",
      imgly: "",
    };
  },
  components: {
    Swiper,
    Slide,
  },
  computed: {},
  created() {
    this.icpUrl = config.icpUrl;
    this.names = config.name;
    this.icpRecord = config.icpRecord;
    (this.login = config.login),
      (this.imgekk = config.imgekk),
      (this.imgly = config.imgly);
  },
  mounted() {
    this.chinaConfigure();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    onleft() {
      this.$refs.swiper.prevSlide();
    },
    onright() {
      this.$refs.swiper.nextSlide();
    },
    handleClick(tab, event) {},
    chinaConfigure() {
      let myChart = echarts.init(this.$refs.myEchart); //这里是为了获得容器所在位置
      // window.onresize = myChart.resize;
      let convertData = function (data) {
        let res = [];
        for (let i = 0; i < data.length; i++) {
          let geoCoord = provin[data[i].name];
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value),
            });
          }
        }
        return res;
      };
      myChart.on("mouseover", function (params) {
        myChart.dispatchAction({
          type: "downplay",
        });
      });
      myChart.setOption({
        // 进行相关配置
        title: {
          // text: "全国网点",
          // subtext: ``,
          left: "center",
        },
        backgroundColor: "#F3F3F3",
        tooltip: {
          formatter: function (params) {
            let items = dataList.filter(function (item) {
              return item.name == params.name;
            });
            if (items != "") {
              if (items[0].name == params.name) {
                let title = items[0].title || "";
                let wenan = items[0].address || "";
                let dh = items[0].Thone || "";
                return `${title}<br>${dh}<br>${wenan}`;
              }
            }
            // console.log(dataList.indexOf(params.name));
          },
        }, // 鼠标移到图里面的浮动提示框
        geo: {
          // 这个是重点配置区
          map: "china", // 表示中国地图
          roam: false,
          label: {
            normal: {
              show: false, // 是否显示对应地名
            },
          },
          itemStyle: {
            normal: {
              borderColor: "rgba(0, 0, 0, 0.7)",
            },
            emphasis: {
              areaColor: null,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
        series: [
          {
            type: "scatter",
            data: convertData(dataList),
            coordinateSystem: "geo", // 对应上方配置
            itemStyle: {
              color: "#ff5252",
            },
          },
          {
            type: "map",
            geoIndex: 0,
          },
        ],
      });
    },
  },
};
</script>
<style lang="less" scoped>
* {
  box-sizing: border-box;
  font-weight: normal;
}
.header {
  margin: 0 auto;
  width: 1200px;
  display: flex;
  justify-content: space-between;
  .header_left {
    display: flex;
    justify-content: space-between;
    .header_icon {
      width: 210px;
      height: 42px;
      background: url("../../../public/image/u117.png");
      background-size: 100%;
    }
    h1 {
      font-weight: 700;
      font-size: 20px;
      color: #ff6600;
    }
  }
  .header_righ {
    display: flex;
    justify-content: space-between;
    a {
      display: block;
      margin: 0 15px;
      cursor: pointer;
      font-weight: 400;
      font-size: 16px;
      line-height: 42px;
      color: #333333;
      text-decoration: none;
    }
    .login {
      margin-top: 5px;
      margin-left: 50px;
      margin-right: 0;
      padding: 0 12px;
      border-radius: 5px;
      height: 32px;
      line-height: 30px;
      border: 1px solid #333;
    }
  }
}
.home {
  max-width: 1920px;
  min-width: 1200px;
}
.swiper-co {
  position: relative;
  width: 100%;
  height: auto;
  .leri {
    position: absolute;
    top: 50%;
    left: 0;
    z-index: 999;
    transform: translateY(-50%);
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    width: 100%;
    height: 82px;
    div {
      opacity: 0;
      cursor: pointer;
      width: 45px;
      height: 82px;
    }
    div:hover {
      opacity: 1;
    }
    .left {
      background: url("../../../public/image/left.png");
    }
    .right {
      background: url("../../../public/image/right.png");
    }
  }
  .back-bq {
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 2;
    width: 100%;
    height: 100px;
    background: url("../../../public/image/bq.png") no-repeat center;
    background-size: 1920px 100px;
  }
}
.wh_slide {
  position: relative;
  height: 680px;
  .back {
    position: relative;
    padding: 70px 50px 0 105px;
    max-width: 1920px;
    min-width: 1200px;
    height: 580px;
    color: #fff;
    .back-1200 {
      width: 1200px;
      margin: 0 auto;
      padding-left: 76px;
    }
  }
  .back-bq2,
  .back-bq3,
  .back-bq4 {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100px;
  }
  .back1,
  .back-bq2 {
    background: #1bd4efff;
    .back-1200 {
      display: flex;
      justify-content: space-between;
      div {
        width: 788px;
        height: 633px;
        background: url("../../../public/image/1.png") no-repeat center;
        background-size: 788px 633px;
      }
    }
    img {
      display: block;
      height: 430px;
    }
  }
  .back3,
  .back-bq3 {
    background: #2695ffff;
    .back-1200 {
      display: flex;
      justify-content: space-between;
      div {
        width: 436px;
        height: 384px;
        background: url("../../../public/image/2.png") no-repeat center;
        background-size: 436px 384px;
      }
    }
    img {
      display: block;
      width: 550px;
      height: 428px;
    }
  }
  .back-bq4 {
    background: #fd8e30ff;
    img {
      display: block;
      width: 398px;
      height: 474px;
    }
  }
  .back4 {
    background: url("../../../public/image/3.png") no-repeat center;
    background-size: 1920px 580px;
  }
}
.tabs-h1 {
  text-align: center;
  margin: 50px auto 23px;
  font-size: 32px;
  color: #333;
}
.tabs-h2 {
  margin: 0 auto;
  text-align: center;
  font-size: 20px;
  color: #fc7100;
}
.home-tabs {
  width: 100%;
  margin: 50px auto 0;
  background: #eee;
  /deep/.el-tabs__nav-wrap {
    padding-bottom: 14px;
    background: #fff;
  }
  /deep/.el-tabs__nav-scroll,
  /deep/.el-tabs__content {
    width: 1200px;
    margin: 0 auto;
  }
  /deep/.el-tabs__nav-wrap::after {
    display: none;
  }
  /deep/.el-tabs__nav {
    height: 50px;
  }
  /deep/.el-tabs__item {
    width: 300px;
    color: #6b6b6b;
    font-size: 24px;
    text-align: center;
  }
  /deep/.is-active {
    color: #ff9900;
  }
  /deep/.el-tabs__item:hover {
    color: #ff9900;
  }
  /deep/.el-tabs__active-bar {
    // display: none;
    background-color: #ff9900;
  }
  /deep/.el-step__title {
    color: #333;
  }
  h1 {
    margin: 0 0 10px 0;
    font-size: 28px;
    color: #333333;
  }
  h2 {
    font-size: 20px;
    color: #333333;
  }
  h3 {
    margin: 0;
    font-size: 16px;
    line-height: 28px;
    color: #333333;
  }
  p {
    font-size: 16px;
    color: #ff9900;
  }
  /deep/.el-steps--vertical {
    height: 120px;
    color: #333;
    /deep/.el-step__icon {
      color: #333;
    }
    /deep/.el-step__icon {
      color: #333;
      border-color: #666;
    }
    /deep/.el-step__line {
      background-color: #666;
    }
  }
  .mobile {
    display: flex;
    justify-content: space-between;
    height: 400px;
    .mobile-left {
      padding-top: 20px;
      padding-left: 90px;
      width: 420px;
    }
    .mobile-righ {
      padding-right: 131px;
      img {
        display: block;
        width: 426px;
        height: 437px;
      }
    }
  }
  .Scan {
    display: flex;
    justify-content: space-between;
    height: 400px;
    .scan_left {
      padding-top: 20px;
      padding-left: 90px;
      width: 400px;
    }
    .scan_righ {
      padding-top: 119px;
      img {
        display: block;
        width: 727px;
        height: 157px;
      }
    }
  }
  .selfh {
    display: flex;
    justify-content: space-between;
    height: 400px;
    .selfh_left {
      padding-top: 20px;
      padding-left: 90px;
      width: 400px;
    }
    .selfh_righ {
      padding: 44px 0 0 0;
      img {
        display: block;
        width: 787px;
        height: 317px;
      }
    }
  }
  .inter {
    display: flex;
    justify-content: space-between;
    height: 400px;
    .inter_left {
      padding-top: 20px;
      padding-left: 90px;
      width: 400px;
    }
    .inter_righ {
      padding-top: 52px;
      img {
        display: block;
        width: 653px;
        height: 289px;
      }
    }
  }
}
.cgal {
  margin: 49px auto 60px;
  h1 {
    margin-bottom: 50px;
    font-size: 32px;
    color: #333;
    text-align: center;
  }
  img {
    display: block;
    margin: 0 auto;
    width: 1200px;
    height: 300px;
  }
}
.gywm {
  margin: 0 auto 50px;
  h1 {
    margin-bottom: 36px;
    font-size: 32px;
    font-weight: 500;
    color: #333333;
    text-align: center;
  }
  .gywm-head {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    width: 1200px;
    text-align: center;
    div {
      position: relative;
      width: 213px;
      height: 270px;
      padding: 0 20px;
      border: 1px solid #333;
      img {
        display: block;
        margin: 24px auto 15px;
        width: 127px;
        height: 127px;
      }
      h2 {
        font-size: 20px;
        margin: 0;
      }
      h3 {
        position: absolute;
        left: 0;
        bottom: 15px;
        margin: 0 auto;
        width: 100%;
        font-size: 24px;
        color: #fc7100;
      }
    }
  }
  .gywm_footer {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 39px auto 0;
    .gywm_left {
      padding-left: 22px;
      width: 617px;
      h4 {
        font-weight: 600;
        margin: 20px 0;
        text-indent: 2em;
        font-size: 18px;
        color: #000;
      }
      p {
        margin: 17px 0 0 0;
        text-indent: 2em;
        font-size: 16px;
        line-height: 24px;
      }
    }
    .gywm_righ {
      padding-top: 24px;
      padding-right: 33px;
      img {
        display: block;
        width: 467px;
        height: 331px;
      }
      h4 {
        margin-top: 30px;
        font-size: 20px;
        color: #000000;
        font-weight: 500;
        width: 467px;
        text-align: center;
      }
    }
  }
}
.qgwd {
  position: relative;
  margin: 0 auto;
  padding: 40px 0 0 0;
  width: 100%;
  background: #f3f3f3;
  h1 {
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 999;
    transform: translateX(-50%);
    text-align: center;
    font-size: 24px;
  }
  h2 {
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
    width: 800px;
    z-index: 999;
    font-size: 16px;
    color: #fc7100;
  }
  .echarts {
    width: 1200px;
    margin: 0 auto;
  }
}
.footer {
  width: 100%;
  padding: 35px 0 40px;
  background: #f2f2f2;
  .footer_1200 {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    width: 1200px;
    color: #333;
    h1,
    h2,
    h3,
    p {
      margin: 0;
    }
    .footer_left {
      display: flex;
      justify-content: space-between;
      padding-top: 14px;
      img {
        width: 82px;
        height: 78px;
        margin-right: 19px;
      }
      h1,
      h2 {
        font-size: 20px;
      }
      h2 {
        margin: 8px 0 16px;
        font-size: 28px;
        color: #fc7100;
      }
      a {
        color: #333;
        text-decoration: none;
        cursor: pointer;
        span {
          margin-left: 20px;
        }
      }
    }
    .footer_cont {
      margin: 0 50px;
      padding: 4px 56px 0;
      height: 129px;
      border-left: #afafaf solid 1px;
      border-right: #afafaf solid 1px;
      p {
        font-size: 16px;
        line-height: 32px;
      }
    }
    .footer_righ {
      width: 272px;
      display: flex;
      justify-content: space-between;
      padding-top: 4px;
      img {
        margin-bottom: 8px;
        display: block;
        width: 110px;
        height: 110px;
      }
      p {
        text-align: center;
        height: 14px;
        font-size: 14px;
      }
    }
  }
}
.lianyun {
  width: 100%;
  background: #e8e8e8;
  padding: 15px 0;
  font-size: 12px;
  color: #666666;
  text-align: center;
  a {
    text-decoration: none;
    color: #666666;
  }
  a:hover {
    color: red;
  }
}
</style>
